// client/src/components/Routing/TerritoryWorkbench/WeekViz/WeekCrewLegend.js

export default function WeekCrewLegend ({ activeCrews, crewColors }) {
  if (!activeCrews?.length) return null
  return (
    <div style={{
      display: 'flex', gap: 14,
      background: 'rgba(251,248,241,0.94)',
      border: '1px solid #e0d8c2', borderRadius: 10, padding: '9px 13px',
      boxShadow: '0 4px 14px rgba(28,36,25,0.14)',
      backdropFilter: 'blur(8px)'
    }}>
      {activeCrews.map(c => (
        <div key={c.crewId} style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
          <span style={{
            width: 11, height: 11, borderRadius: '50%',
            background: crewColors[c.crewId] || '#97a094'
          }} />
          <span style={{ fontSize: 12, fontWeight: 600, color: '#1c2419' }}>
            {c.crewName}
          </span>
        </div>
      ))}
    </div>
  )
}
